import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: {
    thRoot: classnames(
      'border-saffron bg-saffron text-black',
      'inline-flex items-center gap-5 overflow-hidden whitespace-nowrap rounded-pill px-10 py-5 font-sans text-12 font-bold leading-1',
    ),
  },
};
